import React from 'react';
import { Modal, Button } from "@forge/common";
import { CREATE_COURSE_CONSTANTS } from "../utils/constants";

interface UnMountConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    unMountConfirm: () => void;
}

const UnMountConfirmationModal: React.FC<UnMountConfirmationModalProps> = ({
    isOpen,
    onClose,
    unMountConfirm
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        unMountConfirm();
    };

    return (
        <Modal
            className='cancel-confirmation-modal border border-[#E0E0E0] border-[0.2px]'
            backdrop={true}
            footerLeft={
                <div className="flex justify-center">
                    <Button
                        className="cancel-modal-btns mr-4 w-full"
                        id="unMount-no-academy"
                        data-testid="unMount-no-academy"
                        onClick={onClose}
                        size="regular"
                        variant="secondary"
                    >
                        {CREATE_COURSE_CONSTANTS.UNMOUNT_ISO.BUTTONS.NO}
                    </Button>
                    <Button
                        className="cancel-modal-btns w-full"
                        id="unMount-yes-academy"
                        data-testid="unMount-yes-academy"
                        onClick={handleConfirm}
                        size="regular"
                        variant="primary"
                    >
                        {CREATE_COURSE_CONSTANTS.UNMOUNT_ISO.BUTTONS.YES}
                    </Button>
                </div>
            }
            onModalClose={onClose}
            title={CREATE_COURSE_CONSTANTS.UNMOUNT_ISO.TITLE}
        >
            <div className="xl-low:!text-sm xl-mid:!text-base xl-high:!text-lg">
                {CREATE_COURSE_CONSTANTS.UNMOUNT_ISO.MESSAGE}
            </div>
        </Modal>
    );
};

export default UnMountConfirmationModal;